/* tslint:disable */
/* eslint-disable */
/**
 * WESMASH2 CLUB MANAGER 2 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Booking
 */
export interface Booking {
    /**
     * 
     * @type {string}
     * @memberof Booking
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof Booking
     */
    'club_id': string;
    /**
     * 
     * @type {string}
     * @memberof Booking
     */
    'playground_id': string;
}
/**
 * 
 * @export
 * @interface BookingPayment
 */
export interface BookingPayment {
    /**
     * Discriminatore per il tipo di pagamento
     * @type {string}
     * @memberof BookingPayment
     */
    '__t'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingPayment
     */
    'id': string;
    /**
     * ID Utente in formato UUID
     * @type {string}
     * @memberof BookingPayment
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof BookingPayment
     */
    'clubId': string;
    /**
     * Quota richiesta in fase di pagamento
     * @type {number}
     * @memberof BookingPayment
     */
    'quota': number;
    /**
     * Data programmata per l\'avvio delle transazioni
     * @type {string}
     * @memberof BookingPayment
     */
    'dueDate': string;
    /**
     * Data di inizio dell\'evento corrispondente
     * @type {string}
     * @memberof BookingPayment
     */
    'start_at': string;
    /**
     * Data di creazione del ticket
     * @type {string}
     * @memberof BookingPayment
     */
    'createdAt': string;
    /**
     * Stato attuale del pagamento
     * @type {string}
     * @memberof BookingPayment
     */
    'status': BookingPaymentStatusEnum;
    /**
     * ID Booking in formato UUID
     * @type {string}
     * @memberof BookingPayment
     */
    'bookingId': string;
    /**
     * Lista di pagamenti SLAVE che contribuiscono al pagamento MASTER
     * @type {Array<SlavePayment>}
     * @memberof BookingPayment
     */
    'slavePayments': Array<SlavePayment>;
    /**
     * Quota effettivamente pagata dal MASTER, comprensiva delle quote SLAVE non pagate. Disponibile dopo il pagamento
     * @type {number}
     * @memberof BookingPayment
     */
    'paidQuota': number;
}

export const BookingPaymentStatusEnum = {
    Scheduled: 'SCHEDULED',
    Cancelled: 'CANCELLED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Refunded: 'REFUNDED'
} as const;

export type BookingPaymentStatusEnum = typeof BookingPaymentStatusEnum[keyof typeof BookingPaymentStatusEnum];

/**
 * 
 * @export
 * @interface ClubPicture
 */
export interface ClubPicture {
    /**
     * ID dell\'immagine del club
     * @type {string}
     * @memberof ClubPicture
     */
    'id': string;
    /**
     * URL dell\'immagine del club da usare per il download da S3
     * @type {string}
     * @memberof ClubPicture
     */
    'url': string;
    /**
     * Indica se l\'immagine è principale
     * @type {boolean}
     * @memberof ClubPicture
     */
    'is_main': boolean;
}
/**
 * 
 * @export
 * @interface GenericResponseDto
 */
export interface GenericResponseDto {
    /**
     * Response status code
     * @type {number}
     * @memberof GenericResponseDto
     */
    'statusCode': number;
    /**
     * Custom message if any
     * @type {object}
     * @memberof GenericResponseDto
     */
    'message': object;
}
/**
 * 
 * @export
 * @interface GetClubLogoResponse
 */
export interface GetClubLogoResponse {
    /**
     * Collegamento all\'immagine con validità 10 minuti
     * @type {string}
     * @memberof GetClubLogoResponse
     */
    'pictureLink'?: string;
}
/**
 * 
 * @export
 * @interface Membership
 */
export interface Membership {
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'clubName': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'userNome': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'userCognome': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'clubId': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'status': string;
    /**
     * 
     * @type {boolean}
     * @memberof Membership
     */
    'welcomeKitDelivered': boolean;
    /**
     * 
     * @type {number}
     * @memberof Membership
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'paymentMethod': string;
    /**
     * 
     * @type {boolean}
     * @memberof Membership
     */
    'autoRenewal': boolean;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'activationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'renewalDate': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'expirationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'notes': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'ojmarUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'ojmarPermitCode'?: string;
}
/**
 * 
 * @export
 * @interface PaginationDto
 */
export interface PaginationDto {
    /**
     * Number of items on the current page
     * @type {number}
     * @memberof PaginationDto
     */
    'count': number;
    /**
     * Index of the first item on the current page
     * @type {number}
     * @memberof PaginationDto
     */
    'from': number;
    /**
     * Maximum number of items per page
     * @type {number}
     * @memberof PaginationDto
     */
    'limit': number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginationDto
     */
    'page': number;
    /**
     * Index of the last item on the current page
     * @type {number}
     * @memberof PaginationDto
     */
    'to': number;
    /**
     * Total number of items
     * @type {number}
     * @memberof PaginationDto
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PaymentWithBookingDto
 */
export interface PaymentWithBookingDto {
    /**
     * The payment information for the booking
     * @type {BookingPayment}
     * @memberof PaymentWithBookingDto
     */
    'bookingPayment': BookingPayment;
    /**
     * The booking details
     * @type {Booking}
     * @memberof PaymentWithBookingDto
     */
    'booking': Booking;
    /**
     * The user associated with the booking
     * @type {User}
     * @memberof PaymentWithBookingDto
     */
    'user': User;
}
/**
 * 
 * @export
 * @interface SlavePayment
 */
export interface SlavePayment {
    /**
     * ID Utente in formato UUID
     * @type {string}
     * @memberof SlavePayment
     */
    'userId': string;
    /**
     * Quota richiesta in fase di pagamento come contributo al pagamento totale
     * @type {number}
     * @memberof SlavePayment
     */
    'quota': number;
    /**
     * Stato attuale del pagamento
     * @type {string}
     * @memberof SlavePayment
     */
    'status': SlavePaymentStatusEnum;
}

export const SlavePaymentStatusEnum = {
    Scheduled: 'SCHEDULED',
    Cancelled: 'CANCELLED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Refunded: 'REFUNDED'
} as const;

export type SlavePaymentStatusEnum = typeof SlavePaymentStatusEnum[keyof typeof SlavePaymentStatusEnum];

/**
 * 
 * @export
 * @interface UpdateClubLogoRequest
 */
export interface UpdateClubLogoRequest {
    /**
     * Immagine in formato base64
     * @type {string}
     * @memberof UpdateClubLogoRequest
     */
    'picture': string;
}
/**
 * 
 * @export
 * @interface UpdateClubPictureDto
 */
export interface UpdateClubPictureDto {
    /**
     * Immagine in formato base64
     * @type {string}
     * @memberof UpdateClubPictureDto
     */
    'base64': string;
    /**
     * Indica se è l\'immagine principale
     * @type {boolean}
     * @memberof UpdateClubPictureDto
     */
    'isMain': boolean;
}
/**
 * 
 * @export
 * @interface UpdateClubUrlRequest
 */
export interface UpdateClubUrlRequest {
    /**
     * Se non c\'è o stringa vuota, viene rimossa
     * @type {string}
     * @memberof UpdateClubUrlRequest
     */
    'club_url'?: string | null;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id': string;
    /**
     * Version of the user schema, v1 for imported users and v2 for users created on the new app
     * @type {string}
     * @memberof User
     */
    'version': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'oldUserId': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'status': UserStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'role': UserRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'emailVerified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'socialProvided': boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'nome': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'cognome': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'cell'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'cellVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'gender'?: UserGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'dataDiNascita'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'citta'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'situazioneSentimentale'?: UserSituazioneSentimentaleEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'statusProfessionale'?: UserStatusProfessionaleEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'urlFoto'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'profilazioneGG': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'marketingGG': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'marketingTerzeParti': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'terminiCondizioni': boolean;
    /**
     * 
     * @type {object}
     * @memberof User
     */
    'lastSurveyVersion'?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    'favorites'?: Array<string>;
    /**
     * 
     * @type {Array<Membership>}
     * @memberof User
     */
    'memberships'?: Array<Membership>;
}

export const UserStatusEnum = {
    EmailConfirmationPending: 'email_confirmation_pending',
    PhoneConfirmationPending: 'phone_confirmation_pending',
    ProfileInformationPending: 'profile_information_pending',
    Active: 'active',
    Disabled: 'disabled'
} as const;

export type UserStatusEnum = typeof UserStatusEnum[keyof typeof UserStatusEnum];
export const UserRoleEnum = {
    Admin: 'ADMIN',
    ClubManager: 'CLUB_MANAGER',
    Player: 'PLAYER',
    Teacher: 'TEACHER',
    Assistant: 'ASSISTANT'
} as const;

export type UserRoleEnum = typeof UserRoleEnum[keyof typeof UserRoleEnum];
export const UserGenderEnum = {
    Maschio: 'Maschio',
    Femmina: 'Femmina',
    PreferiscoNonRispondere: 'Preferisco non rispondere\"'
} as const;

export type UserGenderEnum = typeof UserGenderEnum[keyof typeof UserGenderEnum];
export const UserSituazioneSentimentaleEnum = {
    Single: 'Single',
    InUnaRelazione: 'In una relazione',
    SposatoA: 'Sposato/a',
    Altro: 'Altro'
} as const;

export type UserSituazioneSentimentaleEnum = typeof UserSituazioneSentimentaleEnum[keyof typeof UserSituazioneSentimentaleEnum];
export const UserStatusProfessionaleEnum = {
    Direttore: 'Direttore',
    Executive: 'Executive',
    Imprenditore: 'Imprenditore',
    Manager: 'Manager',
    ImpiegatoA: 'Impiegato/a',
    LiberoProfessionista: 'Libero professionista',
    PensionatoA: 'Pensionato/a',
    Studente: 'Studente',
    Altro: 'Altro'
} as const;

export type UserStatusProfessionaleEnum = typeof UserStatusProfessionaleEnum[keyof typeof UserStatusProfessionaleEnum];

/**
 * 
 * @export
 * @interface UsersClub
 */
export interface UsersClub {
    /**
     * 
     * @type {string}
     * @memberof UsersClub
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof UsersClub
     */
    'club_id': string;
    /**
     * 
     * @type {string}
     * @memberof UsersClub
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof UsersClub
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersClub
     */
    'family_name'?: string;
    /**
     * 
     * @type {UsersClubExpLevel}
     * @memberof UsersClub
     */
    'exp_level'?: UsersClubExpLevel;
}
/**
 * 
 * @export
 * @interface UsersClubExpLevel
 */
export interface UsersClubExpLevel {
    /**
     * 
     * @type {string}
     * @memberof UsersClubExpLevel
     */
    'icon'?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersClubExpLevel
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersClubExpLevel
     */
    'color'?: string;
    /**
     * 
     * @type {number}
     * @memberof UsersClubExpLevel
     */
    'level'?: number;
}
/**
 * 
 * @export
 * @interface UsersClubsResponseDto
 */
export interface UsersClubsResponseDto {
    /**
     * Array of user-club relations
     * @type {Array<UsersClub>}
     * @memberof UsersClubsResponseDto
     */
    'users': Array<UsersClub>;
    /**
     * Pagination information
     * @type {PaginationDto}
     * @memberof UsersClubsResponseDto
     */
    'pagination': PaginationDto;
}

/**
 * GestioneClubApi - axios parameter creator
 * @export
 */
export const GestioneClubApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * non è possibile cancellare l\'immagine principale (qualla con is_main=true)
         * @summary Cancello un immagine dal club
         * @param {string} clubId id del club
         * @param {string} pictureId id dell\&#39;immagine  (club.pictures.id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClubPicture: async (clubId: string, pictureId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clubId' is not null or undefined
            assertParamExists('deleteClubPicture', 'clubId', clubId)
            // verify required parameter 'pictureId' is not null or undefined
            assertParamExists('deleteClubPicture', 'pictureId', pictureId)
            const localVarPath = `/v2/gestioneclub/{clubId}/image/{pictureId}`
                .replace(`{${"clubId"}}`, encodeURIComponent(String(clubId)))
                .replace(`{${"pictureId"}}`, encodeURIComponent(String(pictureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ritorna i pagamenti del club
         * @param {string} clubId ID del club
         * @param {string} date Filtro per data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPaymentsForClub: async (clubId: string, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clubId' is not null or undefined
            assertParamExists('findPaymentsForClub', 'clubId', clubId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('findPaymentsForClub', 'date', date)
            const localVarPath = `/v2/gestioneclub/{clubId}/payments`
                .replace(`{${"clubId"}}`, encodeURIComponent(String(clubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ritorna gli utenti del club
         * @param {string} id 
         * @param {number} [limit] Risultati per pagina
         * @param {number} [page] Numero pagina
         * @param {number} [minCancellations] Numero minimo di cancellazioni
         * @param {number} [minBookings] Numero minimo di prenotazioni
         * @param {string} [banned] Filtro per utenti bannati (true/false)
         * @param {string} [name] Filtro per nome utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUsersClubsForClub: async (id: string, limit?: number, page?: number, minCancellations?: number, minBookings?: number, banned?: string, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findUsersClubsForClub', 'id', id)
            const localVarPath = `/v2/gestioneclub/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (minCancellations !== undefined) {
                localVarQueryParameter['min_cancellations'] = minCancellations;
            }

            if (minBookings !== undefined) {
                localVarQueryParameter['min_bookings'] = minBookings;
            }

            if (banned !== undefined) {
                localVarQueryParameter['banned'] = banned;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Leggo il club 
         * @param {string} clubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClub: async (clubId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clubId' is not null or undefined
            assertParamExists('getClub', 'clubId', clubId)
            const localVarPath = `/v2/gestioneclub/get-club`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clubId !== undefined) {
                localVarQueryParameter['club_id'] = clubId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Leggo i campi del club e del campo di gioco
         * @param {string} playgroundId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClubFromPlayground: async (playgroundId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'playgroundId' is not null or undefined
            assertParamExists('getClubFromPlayground', 'playgroundId', playgroundId)
            const localVarPath = `/v2/gestioneclub/get-club-for-playground`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (playgroundId !== undefined) {
                localVarQueryParameter['playground_id'] = playgroundId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Leggo il club 
         * @param {string} clubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClubFull: async (clubId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clubId' is not null or undefined
            assertParamExists('getClubFull', 'clubId', clubId)
            const localVarPath = `/v2/gestioneclub/get-club-full`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clubId !== undefined) {
                localVarQueryParameter['club_id'] = clubId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ottieni il logo del club
         * @param {string} id ID del club
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClubLogo: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getClubLogo', 'id', id)
            const localVarPath = `/v2/gestioneclub/{id}/logo`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Leggo le immagini del club
         * @param {string} clubId id del club
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClubPictures: async (clubId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clubId' is not null or undefined
            assertParamExists('getClubPictures', 'clubId', clubId)
            const localVarPath = `/v2/gestioneclub/{clubId}/images`
                .replace(`{${"clubId"}}`, encodeURIComponent(String(clubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Leggo uno userclub 
         * @param {string} clubId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserClubByUserId: async (clubId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clubId' is not null or undefined
            assertParamExists('getUserClubByUserId', 'clubId', clubId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserClubByUserId', 'userId', userId)
            const localVarPath = `/v2/gestioneclub/{clubId}/userclub/{userId}`
                .replace(`{${"clubId"}}`, encodeURIComponent(String(clubId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apri porta per il club
         * @param {string} id ID del club
         * @param {string} porta Nome della porta da aprire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openDoor: async (id: string, porta: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('openDoor', 'id', id)
            // verify required parameter 'porta' is not null or undefined
            assertParamExists('openDoor', 'porta', porta)
            const localVarPath = `/v2/gestioneclub/open-door/{id}/{porta}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"porta"}}`, encodeURIComponent(String(porta)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * non è possibile impostare come principale un\'immagine già principale e ci può essere solo un\'immagine principale
         * @summary Imposto un immagine del club come principale
         * @param {string} clubId id del club
         * @param {string} pictureId id dell\&#39;immagine  (club.pictures.id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMainClubPicture: async (clubId: string, pictureId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clubId' is not null or undefined
            assertParamExists('setMainClubPicture', 'clubId', clubId)
            // verify required parameter 'pictureId' is not null or undefined
            assertParamExists('setMainClubPicture', 'pictureId', pictureId)
            const localVarPath = `/v2/gestioneclub/{clubId}/image/{pictureId}/main`
                .replace(`{${"clubId"}}`, encodeURIComponent(String(clubId)))
                .replace(`{${"pictureId"}}`, encodeURIComponent(String(pictureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Carica un logo per il club
         * @param {string} id ID del club
         * @param {UpdateClubLogoRequest} updateClubLogoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClubLogo: async (id: string, updateClubLogoRequest: UpdateClubLogoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateClubLogo', 'id', id)
            // verify required parameter 'updateClubLogoRequest' is not null or undefined
            assertParamExists('updateClubLogo', 'updateClubLogoRequest', updateClubLogoRequest)
            const localVarPath = `/v2/gestioneclub/{id}/logo`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClubLogoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aggiungo un immagine al club
         * @param {string} clubId id del club
         * @param {UpdateClubPictureDto} updateClubPictureDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClubPicture: async (clubId: string, updateClubPictureDto: UpdateClubPictureDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clubId' is not null or undefined
            assertParamExists('updateClubPicture', 'clubId', clubId)
            // verify required parameter 'updateClubPictureDto' is not null or undefined
            assertParamExists('updateClubPicture', 'updateClubPictureDto', updateClubPictureDto)
            const localVarPath = `/v2/gestioneclub/{clubId}/image`
                .replace(`{${"clubId"}}`, encodeURIComponent(String(clubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClubPictureDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aggiorna l\'URL del club
         * @param {string} clubId id del club
         * @param {UpdateClubUrlRequest} updateClubUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClubUrl: async (clubId: string, updateClubUrlRequest: UpdateClubUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clubId' is not null or undefined
            assertParamExists('updateClubUrl', 'clubId', clubId)
            // verify required parameter 'updateClubUrlRequest' is not null or undefined
            assertParamExists('updateClubUrl', 'updateClubUrlRequest', updateClubUrlRequest)
            const localVarPath = `/v2/gestioneclub/{clubId}/url`
                .replace(`{${"clubId"}}`, encodeURIComponent(String(clubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClubUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GestioneClubApi - functional programming interface
 * @export
 */
export const GestioneClubApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GestioneClubApiAxiosParamCreator(configuration)
    return {
        /**
         * non è possibile cancellare l\'immagine principale (qualla con is_main=true)
         * @summary Cancello un immagine dal club
         * @param {string} clubId id del club
         * @param {string} pictureId id dell\&#39;immagine  (club.pictures.id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClubPicture(clubId: string, pictureId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClubPicture(clubId, pictureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GestioneClubApi.deleteClubPicture']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ritorna i pagamenti del club
         * @param {string} clubId ID del club
         * @param {string} date Filtro per data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPaymentsForClub(clubId: string, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentWithBookingDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPaymentsForClub(clubId, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GestioneClubApi.findPaymentsForClub']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ritorna gli utenti del club
         * @param {string} id 
         * @param {number} [limit] Risultati per pagina
         * @param {number} [page] Numero pagina
         * @param {number} [minCancellations] Numero minimo di cancellazioni
         * @param {number} [minBookings] Numero minimo di prenotazioni
         * @param {string} [banned] Filtro per utenti bannati (true/false)
         * @param {string} [name] Filtro per nome utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUsersClubsForClub(id: string, limit?: number, page?: number, minCancellations?: number, minBookings?: number, banned?: string, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersClubsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUsersClubsForClub(id, limit, page, minCancellations, minBookings, banned, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GestioneClubApi.findUsersClubsForClub']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Leggo il club 
         * @param {string} clubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClub(clubId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClub(clubId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GestioneClubApi.getClub']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Leggo i campi del club e del campo di gioco
         * @param {string} playgroundId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClubFromPlayground(playgroundId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClubFromPlayground(playgroundId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GestioneClubApi.getClubFromPlayground']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Leggo il club 
         * @param {string} clubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClubFull(clubId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClubFull(clubId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GestioneClubApi.getClubFull']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ottieni il logo del club
         * @param {string} id ID del club
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClubLogo(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClubLogoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClubLogo(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GestioneClubApi.getClubLogo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Leggo le immagini del club
         * @param {string} clubId id del club
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClubPictures(clubId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClubPicture>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClubPictures(clubId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GestioneClubApi.getClubPictures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Leggo uno userclub 
         * @param {string} clubId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserClubByUserId(clubId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersClub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserClubByUserId(clubId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GestioneClubApi.getUserClubByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Apri porta per il club
         * @param {string} id ID del club
         * @param {string} porta Nome della porta da aprire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openDoor(id: string, porta: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openDoor(id, porta, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GestioneClubApi.openDoor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * non è possibile impostare come principale un\'immagine già principale e ci può essere solo un\'immagine principale
         * @summary Imposto un immagine del club come principale
         * @param {string} clubId id del club
         * @param {string} pictureId id dell\&#39;immagine  (club.pictures.id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setMainClubPicture(clubId: string, pictureId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setMainClubPicture(clubId, pictureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GestioneClubApi.setMainClubPicture']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Carica un logo per il club
         * @param {string} id ID del club
         * @param {UpdateClubLogoRequest} updateClubLogoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClubLogo(id: string, updateClubLogoRequest: UpdateClubLogoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClubLogo(id, updateClubLogoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GestioneClubApi.updateClubLogo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aggiungo un immagine al club
         * @param {string} clubId id del club
         * @param {UpdateClubPictureDto} updateClubPictureDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClubPicture(clubId: string, updateClubPictureDto: UpdateClubPictureDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClubPicture(clubId, updateClubPictureDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GestioneClubApi.updateClubPicture']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aggiorna l\'URL del club
         * @param {string} clubId id del club
         * @param {UpdateClubUrlRequest} updateClubUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClubUrl(clubId: string, updateClubUrlRequest: UpdateClubUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClubUrl(clubId, updateClubUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GestioneClubApi.updateClubUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GestioneClubApi - factory interface
 * @export
 */
export const GestioneClubApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GestioneClubApiFp(configuration)
    return {
        /**
         * non è possibile cancellare l\'immagine principale (qualla con is_main=true)
         * @summary Cancello un immagine dal club
         * @param {string} clubId id del club
         * @param {string} pictureId id dell\&#39;immagine  (club.pictures.id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClubPicture(clubId: string, pictureId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteClubPicture(clubId, pictureId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ritorna i pagamenti del club
         * @param {string} clubId ID del club
         * @param {string} date Filtro per data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPaymentsForClub(clubId: string, date: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaymentWithBookingDto>> {
            return localVarFp.findPaymentsForClub(clubId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ritorna gli utenti del club
         * @param {string} id 
         * @param {number} [limit] Risultati per pagina
         * @param {number} [page] Numero pagina
         * @param {number} [minCancellations] Numero minimo di cancellazioni
         * @param {number} [minBookings] Numero minimo di prenotazioni
         * @param {string} [banned] Filtro per utenti bannati (true/false)
         * @param {string} [name] Filtro per nome utente
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUsersClubsForClub(id: string, limit?: number, page?: number, minCancellations?: number, minBookings?: number, banned?: string, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<UsersClubsResponseDto> {
            return localVarFp.findUsersClubsForClub(id, limit, page, minCancellations, minBookings, banned, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Leggo il club 
         * @param {string} clubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClub(clubId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getClub(clubId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Leggo i campi del club e del campo di gioco
         * @param {string} playgroundId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClubFromPlayground(playgroundId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getClubFromPlayground(playgroundId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Leggo il club 
         * @param {string} clubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClubFull(clubId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getClubFull(clubId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ottieni il logo del club
         * @param {string} id ID del club
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClubLogo(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GetClubLogoResponse> {
            return localVarFp.getClubLogo(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Leggo le immagini del club
         * @param {string} clubId id del club
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClubPictures(clubId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ClubPicture>> {
            return localVarFp.getClubPictures(clubId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Leggo uno userclub 
         * @param {string} clubId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserClubByUserId(clubId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UsersClub> {
            return localVarFp.getUserClubByUserId(clubId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apri porta per il club
         * @param {string} id ID del club
         * @param {string} porta Nome della porta da aprire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openDoor(id: string, porta: string, options?: RawAxiosRequestConfig): AxiosPromise<GenericResponseDto> {
            return localVarFp.openDoor(id, porta, options).then((request) => request(axios, basePath));
        },
        /**
         * non è possibile impostare come principale un\'immagine già principale e ci può essere solo un\'immagine principale
         * @summary Imposto un immagine del club come principale
         * @param {string} clubId id del club
         * @param {string} pictureId id dell\&#39;immagine  (club.pictures.id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMainClubPicture(clubId: string, pictureId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setMainClubPicture(clubId, pictureId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Carica un logo per il club
         * @param {string} id ID del club
         * @param {UpdateClubLogoRequest} updateClubLogoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClubLogo(id: string, updateClubLogoRequest: UpdateClubLogoRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenericResponseDto> {
            return localVarFp.updateClubLogo(id, updateClubLogoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aggiungo un immagine al club
         * @param {string} clubId id del club
         * @param {UpdateClubPictureDto} updateClubPictureDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClubPicture(clubId: string, updateClubPictureDto: UpdateClubPictureDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateClubPicture(clubId, updateClubPictureDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aggiorna l\'URL del club
         * @param {string} clubId id del club
         * @param {UpdateClubUrlRequest} updateClubUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClubUrl(clubId: string, updateClubUrlRequest: UpdateClubUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateClubUrl(clubId, updateClubUrlRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GestioneClubApi - object-oriented interface
 * @export
 * @class GestioneClubApi
 * @extends {BaseAPI}
 */
export class GestioneClubApi extends BaseAPI {
    /**
     * non è possibile cancellare l\'immagine principale (qualla con is_main=true)
     * @summary Cancello un immagine dal club
     * @param {string} clubId id del club
     * @param {string} pictureId id dell\&#39;immagine  (club.pictures.id)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GestioneClubApi
     */
    public deleteClubPicture(clubId: string, pictureId: string, options?: RawAxiosRequestConfig) {
        return GestioneClubApiFp(this.configuration).deleteClubPicture(clubId, pictureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ritorna i pagamenti del club
     * @param {string} clubId ID del club
     * @param {string} date Filtro per data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GestioneClubApi
     */
    public findPaymentsForClub(clubId: string, date: string, options?: RawAxiosRequestConfig) {
        return GestioneClubApiFp(this.configuration).findPaymentsForClub(clubId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ritorna gli utenti del club
     * @param {string} id 
     * @param {number} [limit] Risultati per pagina
     * @param {number} [page] Numero pagina
     * @param {number} [minCancellations] Numero minimo di cancellazioni
     * @param {number} [minBookings] Numero minimo di prenotazioni
     * @param {string} [banned] Filtro per utenti bannati (true/false)
     * @param {string} [name] Filtro per nome utente
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GestioneClubApi
     */
    public findUsersClubsForClub(id: string, limit?: number, page?: number, minCancellations?: number, minBookings?: number, banned?: string, name?: string, options?: RawAxiosRequestConfig) {
        return GestioneClubApiFp(this.configuration).findUsersClubsForClub(id, limit, page, minCancellations, minBookings, banned, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Leggo il club 
     * @param {string} clubId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GestioneClubApi
     */
    public getClub(clubId: string, options?: RawAxiosRequestConfig) {
        return GestioneClubApiFp(this.configuration).getClub(clubId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Leggo i campi del club e del campo di gioco
     * @param {string} playgroundId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GestioneClubApi
     */
    public getClubFromPlayground(playgroundId: string, options?: RawAxiosRequestConfig) {
        return GestioneClubApiFp(this.configuration).getClubFromPlayground(playgroundId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Leggo il club 
     * @param {string} clubId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GestioneClubApi
     */
    public getClubFull(clubId: string, options?: RawAxiosRequestConfig) {
        return GestioneClubApiFp(this.configuration).getClubFull(clubId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ottieni il logo del club
     * @param {string} id ID del club
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GestioneClubApi
     */
    public getClubLogo(id: string, options?: RawAxiosRequestConfig) {
        return GestioneClubApiFp(this.configuration).getClubLogo(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Leggo le immagini del club
     * @param {string} clubId id del club
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GestioneClubApi
     */
    public getClubPictures(clubId: string, options?: RawAxiosRequestConfig) {
        return GestioneClubApiFp(this.configuration).getClubPictures(clubId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Leggo uno userclub 
     * @param {string} clubId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GestioneClubApi
     */
    public getUserClubByUserId(clubId: string, userId: string, options?: RawAxiosRequestConfig) {
        return GestioneClubApiFp(this.configuration).getUserClubByUserId(clubId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apri porta per il club
     * @param {string} id ID del club
     * @param {string} porta Nome della porta da aprire
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GestioneClubApi
     */
    public openDoor(id: string, porta: string, options?: RawAxiosRequestConfig) {
        return GestioneClubApiFp(this.configuration).openDoor(id, porta, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * non è possibile impostare come principale un\'immagine già principale e ci può essere solo un\'immagine principale
     * @summary Imposto un immagine del club come principale
     * @param {string} clubId id del club
     * @param {string} pictureId id dell\&#39;immagine  (club.pictures.id)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GestioneClubApi
     */
    public setMainClubPicture(clubId: string, pictureId: string, options?: RawAxiosRequestConfig) {
        return GestioneClubApiFp(this.configuration).setMainClubPicture(clubId, pictureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Carica un logo per il club
     * @param {string} id ID del club
     * @param {UpdateClubLogoRequest} updateClubLogoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GestioneClubApi
     */
    public updateClubLogo(id: string, updateClubLogoRequest: UpdateClubLogoRequest, options?: RawAxiosRequestConfig) {
        return GestioneClubApiFp(this.configuration).updateClubLogo(id, updateClubLogoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aggiungo un immagine al club
     * @param {string} clubId id del club
     * @param {UpdateClubPictureDto} updateClubPictureDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GestioneClubApi
     */
    public updateClubPicture(clubId: string, updateClubPictureDto: UpdateClubPictureDto, options?: RawAxiosRequestConfig) {
        return GestioneClubApiFp(this.configuration).updateClubPicture(clubId, updateClubPictureDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aggiorna l\'URL del club
     * @param {string} clubId id del club
     * @param {UpdateClubUrlRequest} updateClubUrlRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GestioneClubApi
     */
    public updateClubUrl(clubId: string, updateClubUrlRequest: UpdateClubUrlRequest, options?: RawAxiosRequestConfig) {
        return GestioneClubApiFp(this.configuration).updateClubUrl(clubId, updateClubUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PingApi - axios parameter creator
 * @export
 */
export const PingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PingApi - functional programming interface
 * @export
 */
export const PingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ping(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ping(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PingApi.ping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PingApi - factory interface
 * @export
 */
export const PingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PingApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.ping(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PingApi - object-oriented interface
 * @export
 * @class PingApi
 * @extends {BaseAPI}
 */
export class PingApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingApi
     */
    public ping(options?: RawAxiosRequestConfig) {
        return PingApiFp(this.configuration).ping(options).then((request) => request(this.axios, this.basePath));
    }
}



